import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { ModalCloseButton } from "./ModalCloseButton";
import { useRsi } from "../hooks/useRsi";
export const ModalWrapper = ({ children, isOpen, onClose }) => {
    const { rtl } = useRsi();
    return (_jsx(Modal, Object.assign({ isOpen: isOpen, onClose: onClose, id: "rsi", variant: "rsi", closeOnEsc: false, closeOnOverlayClick: false, scrollBehavior: "inside", size: "6xl" }, { children: _jsxs("div", Object.assign({ dir: rtl ? "rtl" : "ltr" }, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { children: [_jsx(ModalCloseButton, { onClose: onClose }), children] })] })) })));
};
